// Local translations
export const T = {
  en_GB: {
    allowedPortfolioTypes: "Allowed Portfolio Types",
    portfolioTypesDesc: "Select which portfolio types advisors can choose for this portfolio",
    modelPortfolio: "Model Portfolio (auto-selected based on risk assessment)",
    customPortfolio: "Custom Portfolio (manual product selection and amounts)",
    dynamicPortfolio: "Dynamic Portfolio (generated from the client's data)",
    atLeastOnePortfolioType: "At least one portfolio type must be allowed",
    showPortfolioName: "Show Portfolio Name",
    portfolioNameDesc: "Display the name field for this portfolio",
    showDateInputs: "Show Date Inputs",
    dateInputsDesc: "Display date fields for one-time and recurring schedules",
  },
  nb_NO: {
    allowedPortfolioTypes: "Tillatte porteføljetyper",
    portfolioTypesDesc: "Velg hvilke porteføljetyper rådgivere kan velge for denne porteføljen",
    modelPortfolio: "Modellportefølje (automatisk valgt basert på risikovurdering)",
    customPortfolio: "Tilpasset portefølje (manuelt produktutvalg og beløp)",
    dynamicPortfolio: "Dynamisk portefølje (generert fra kundens data)",
    atLeastOnePortfolioType: "Minst én porteføljetype må være tillatt",
    showPortfolioName: "Vis porteføljenavn",
    portfolioNameDesc: "Vis navnefeltet for denne porteføljen",
    showDateInputs: "Vis datoinndatafelter",
    dateInputsDesc: "Vis datofelter for engangs- og gjentakende tidsplaner",
  },
} as const;
